<template>
    <v-autocomplete
      v-model="select"
      :loading="isLoading"
      :items="itemsFiltered"
      :search-input.sync="searchInput"
      class="mx-3 global-search"
      flat
      :filter="v => v"
      :hide-details="hideDetails"
      single-line
      hide-no-data
      label="Search"
      :solo-inverted = "solo"
      prepend-inner-icon="search"
      return-object
      dense
      @change="go"
      append-icon=""
      @blur="reset"
      hideDetails

    >
        <v-slide-x-transition
          slot="prepend-inner"
          mode="out-in"
        >
          <v-icon key="icon-0" >search</v-icon>
        </v-slide-x-transition>
    <div
        slot="prepend-item"
        class="px-3 grey--text">
      items found: {{ itemsFiltered.length }}
    </div>

      <template no-filter v-slot:item="{ item }" class="global-search">
        <v-list-item-avatar>
          <v-icon>assignment</v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title> Booking: {{ item.id }} - {{ item.ap_date }} {{ item.ap_time | formatTime }}</v-list-item-title>
          <v-list-item-subtitle> Traject: {{ item.client_lastname }} {{ item.client_firstname }}- {{ item.destination_name }} </v-list-item-subtitle>
          <v-list-item-subtitle>Driver: {{ item.driver_firstname }} {{ item.driver_lastname }}</v-list-item-subtitle>
        </v-list-item-content>
      </template>


              </v-autocomplete>
</template>
<script>
  import moment from 'moment';
  export default {
    props: {
      items: {
        type: Array,
        default: () => []
      },
      global: {
        type: Boolean,
        default: false
      },
      solo: {
        type: Boolean,
        default: false
      },
      hideDetails: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        isLoading: false,
        select: null,
        query: ''
      }
    },
    methods: {
      go (item) {
        this.$emit('search', item);
        this.$nextTick(() => {
          this.reset()
        })
      },
      reset () {
        // console.log('on blur ');
        this.isLoading = false;
        this.select = null;
        this.query = '';
      }
    },
    computed: {
      searchInput: {
        get: () => '',
        set: function (v) {
          this.query = (typeof v === 'string') ? v : '';
        }
      },
      itemsFiltered () {
        var query = this.query;
        var querys;
        if ((typeof query === 'string' || query instanceof String) && query !== '') {
          querys = query.split(' ');
          return this.items.filter(item => {
            return querys.every(q => {
              return item.search.toLowerCase().includes(q.toLowerCase());
            });
          })
        } else {
          return []
        }
      }
    },
    filters: {
      date: function (date) {
        return moment(date).format('DD/MM/YYYY');
      }
    }
  }
</script>
<style lang="scss">

    .v-autocomplete__content {
      .v-list__tile, .v-list--dense .v-list__tile:not(.v-list__tile--avatar) {
        height: auto;
        padding: 5px 16px;
      }
      div[role=listitem] {
        .v-list__tile__title {
          color: rgba(0,0,0,.87);
          height: auto;
          line-height: inherit;
        }
      }

    }
    .v-autocomplete.v-input--is-focused {
      .v-input__prepend-inner .theme--dark.v-icon {
        color: #e5332a;
      }
    }
  .grey-line {
    border-top: solid 1px #b9b8b8;
  }
  .invoice.status {
    text-transform: none;
    &-0 {
      color:rgba(248, 1, 1, 1) !important;
    }
    &-1 {
      color:rgba(32, 151, 2, 1) !important;
    }
    &-2 {
      color:rgba(248, 1, 1, 1) !important;
    }
}

</style>

